import ErrorView from '../../views/error';
import CenteredBoxLayout from '../../layouts/centered-box';

const routes = [
  {
    path: '/error/:id?',
    exact: true,
    secure: false,
    layout: CenteredBoxLayout,
    component: ErrorView,
  },
];

export default {routes};
